// turn live chat on/off on different country
const liveChat = {
  AU: true,
  NZ: false,
  ID: true,
};

export default liveChat;
